import React from "react"
import TaskIcon from "../../../../../gd-components/icons/task-icon/task-icon-ui5";
import {FieldCSVImportPreviewProps} from "../../../../render/csv-import-preview";

export default function FieldTaskType_CSVImportPreview(props:FieldCSVImportPreviewProps) {

    // return <TaskTypeValue field={this} value={model[this.fieldId]} className={className} params={params} />

    const value : string = props.model[props.field.fieldId]

    const taskType = gd.session.taskTypes.get(value);
    if (!taskType) return false;

    return <>
        <TaskIcon taskType={taskType}
                  className={props.className}
                  size='13'
        />
        <div className="ui5-txt-less-important-small m-l-5">{taskType.name}</div>
    </>

}
